import React from 'react';
import { Phone, Clock, MessageSquare } from 'lucide-react';

export function Contact() {
  const contactInfo = [
    // {
    //   icon: <MapPin className="w-6 h-6" />,
    //   title: "Notre Adresse",
    //   description: "123 Avenue des Arts\n75001 Paris, France",
    //   action: "Voir sur la carte"
    // },
    {
      icon: <Phone className='w-6 h-6' />,
      title: 'Téléphone',
      description: '06 49 99 66 34',
      action: '',
    },
    // {
    //   icon: <Mail className="w-6 h-6" />,
    //   title: "Email",
    //   description: "contact@example.com\nsupport@example.com",
    //   action: "Envoyez-nous un email"
    // },
    {
      icon: <Clock className='w-6 h-6' />,
      title: "Horaires d'Ouverture",
      description: 'Lundi - Vendredi: 9h30 - 20h',
      action: '',
    },
  ];

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   // Handle form submission
  // };

  return (
    <div id='contact' className='min-h-screen bg-gray-50'>
      {/* <header className="bg-white shadow-sm"> */}
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6'>
        <div className='flex items-center space-x-3'>
          <MessageSquare className='text-blue-600 w-8 h-8' />
          <h1 className='text-2xl font-bold text-gray-900'>Contactez-nous</h1>
        </div>
      </div>
      {/* </header> */}

      <main className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12'>
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-12'>
          {/* Contact Information */}
          <div className='space-y-8'>
            <div>
              <h2 className='text-3xl font-bold text-gray-900 mb-6'>
                Restons en Contact
              </h2>
              <p className='text-gray-600 mb-8'>
                Nous sommes là pour vous aider. N'hésitez pas à nous contacter
                pour toute question ou demande d'information. Notre équipe vous
                répondra dans les plus brefs délais.
              </p>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
              {contactInfo.map((info, index) => (
                <div
                  key={index}
                  className='bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow'
                >
                  <div className='text-blue-600 mb-4'>{info.icon}</div>
                  <h3 className='text-lg font-semibold text-gray-900 mb-2'>
                    {info.title}
                  </h3>
                  <p className='text-gray-600 whitespace-pre-line mb-4'>
                    {info.description}
                  </p>
                  <button className='text-blue-600 hover:text-blue-700 text-sm font-medium'>
                    {info.action}
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Form */}
          {/* <div className='bg-white rounded-xl shadow-lg p-8'>
            <h2 className='text-2xl font-bold text-gray-900 mb-6'>
              Envoyez-nous un Message
            </h2>
            <form onSubmit={handleSubmit} className='space-y-6'>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                <div>
                  <label
                    htmlFor='firstName'
                    className='block text-sm font-medium text-gray-700 mb-2'
                  >
                    Prénom
                  </label>
                  <input
                    type='text'
                    id='firstName'
                    className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent'
                    placeholder='Jean'
                  />
                </div>
                <div>
                  <label
                    htmlFor='lastName'
                    className='block text-sm font-medium text-gray-700 mb-2'
                  >
                    Nom
                  </label>
                  <input
                    type='text'
                    id='lastName'
                    className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent'
                    placeholder='Dupont'
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor='email'
                  className='block text-sm font-medium text-gray-700 mb-2'
                >
                  Email
                </label>
                <input
                  type='email'
                  id='email'
                  className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent'
                  placeholder='jean.dupont@example.com'
                />
              </div>

              <div>
                <label
                  htmlFor='subject'
                  className='block text-sm font-medium text-gray-700 mb-2'
                >
                  Sujet
                </label>
                <input
                  type='text'
                  id='subject'
                  className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent'
                  placeholder='Comment pouvons-nous vous aider ?'
                />
              </div>

              <div>
                <label
                  htmlFor='message'
                  className='block text-sm font-medium text-gray-700 mb-2'
                >
                  Message
                </label>
                <textarea
                  id='message'
                  rows={4}
                  className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent resize-none'
                  placeholder='Écrivez votre message ici...'
                />
              </div>

              <button
                type='submit'
                className='w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2'
              >
                <Send className='w-5 h-5' />
                <span>Envoyer le Message</span>
              </button>
            </form>
          </div> */}
        </div>
      </main>
    </div>
  );
}
